import { render, staticRenderFns } from "./scratch-card.vue?vue&type=template&id=f0758e06&scoped=true"
import script from "./scratch-card.vue?vue&type=script&lang=js"
export * from "./scratch-card.vue?vue&type=script&lang=js"
import style0 from "./scratch-card.vue?vue&type=style&index=0&id=f0758e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0758e06",
  null
  
)

export default component.exports